'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _episodelist = require('./episodelist.html');

var _episodelist2 = _interopRequireDefault(_episodelist);

var _episodelist3 = require('./episodelist.controller');

var _episodelist4 = _interopRequireDefault(_episodelist3);

require('./episodelist.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var episodelistComponent = {
  restrict: 'E',
  bindings: {},
  template: _episodelist2.default,
  controller: _episodelist4.default,
  controllerAs: 'vm'
};

exports.default = episodelistComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/episodelist/episodelist.component.js